<template>
  <div id="personal">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <b-col lg="12" md="12">

          <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
            <h2 class="section-title">Personal Projects</h2>
            <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
          </div>
          <div>

            <div v-scroll-reveal="{ delay: 100 }">
              <b-row>
                <b-col lg="3" md="4" style="text-align: center;">
                  <img src="/edendark.png" width="120" />
                  <div class="uni" style="margin-bottom: 40px; margin-top: 20px;">March 2023 - Present</div>
                </b-col>
                <b-col lg="9" md="8">
                  <p class="section-subtitle" style=" font-size: 18px;">Eden Couture, LLC</p>
                  <p>
                    Eden Couture is a platform I co-founded dedicated to connecting shoppers with independent designers
                    through a curated marketplace for festival fashion. The platform allows users to discover and shop
                    multiple brands in one place, while also offering custom design services for one-of-a-kind pieces.
                  </p>
                  <br/>
                  <p>
                    Eden is rooted in community, creativity, and a mission to uplift artists within the festival space by
                    making their work more accessible and discoverable.
                  </p>
                  <br/>
                  <div>Through building Eden, I've developed and applied a wide range of skills across both creative and
                    operational areas, including:</div>
                  <ul style="padding-left: 20px; margin-top: 10px;">
                    <li><b>Social media strategy & growth:</b> Leading content strategy and execution to build brand
                      awareness and engagement across platforms.</li>
                    <li><b>Content creation:</b> Designing visual and written content that reflects the brand identity and
                      resonates with our audience.</li>
                    <li><b>Designer relations:</b> Managing and onboarding a network of 20+ independent designers,
                      gathering feedback, and fostering long-term collaboration.</li>
                    <li><b>Marketplace development:</b> Helping shape the structure, flow, and user experience of a
                      multi-brand e-commerce platform.</li>
                    <li><b>Website strategy:</b> Collaborating on layout, design, and ongoing updates to improve usability
                      and conversion.</li>
                    <li><b>Client experience:</b> Managing communication and ensuring a seamless experience across both
                      custom and shop orders.</li>
                    <li><b>Event marketing & brand activation:</b> Representing Eden at festivals, fashion shows, and
                      other events, coordinating logistics, and building community connections.</li>
                    <li><b>Project management:</b> Setting and executing short- and long-term goals aligned with the
                      platform's growth and vision.</li>
                  </ul>

                  <br /><br />
                  <div style="text-align: center;">
                    <a href="https://edencouture.co/collections" class="eden-button" target="_blank" style="margin-right: 10px;">Visit Eden</a>
                    <a href="https://instagram.com/edencouture.co" class="eden-button" target="_blank">Instagram</a>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      skillItems: [
        {
          img: '/wordlogo.png',
          text: 'MS Word'
        },
        {
          img: '/excellogo.png',
          text: 'MS Excel'
        },
        {
          img: '/abacuslogo.png',
          text: 'Abacus Law'
        },
        {
          img: '/lexisnexis.png',
          text: 'Lexis Nexis'
        },
      ]
    }
  }
}
</script>

<style lang="css">.eden-button {
  background: #ffa318;
  color: white !important;
  padding: 8px 15px;
  border-radius: 10px;
  text-decoration: none !important;
  transition: all .2s ease;
}

.eden-button:hover {
  background: #ffa318cc;
}</style>
